import { TextField, TextFieldProps } from '@material-ui/core';

export default function TextInput({
    label,
    id = 'textinput',
    variant = 'filled',
    ...rest
}: TextFieldProps) {
    return <TextField id={id} label={label} variant={variant} {...rest} autoComplete={'off'} />;
}
